module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/vectors/term-bg-3-f90a252afca441f3cfed36b5c7e53d16.jpg";